const CommonServerRoute = {
    live_account: 'accounts.themunim.com',
    dev_account: 'devaccounts.themunim.com',
    stage_account: 'stageaccounts.themunim.com',
    qa_account: 'qaaccounts.themunim.com',
    dev_gst: 'devgst.themunim.com',
    dev_app: 'dev.themunim.com',
    dev_ecom: 'devecom.themunim.com',
    stage_app: 'stage.themunim.com',
    stage_gst: 'stagegst.themunim.com',
    live_gst: 'gst.themunim.com',
    live_app: 'app.themunim.com',
    qa_app: 'qa.themunim.com',
    live_ecom: 'ecommerce.themunim.com',
    dev1_app: 'dev1.themunim.com',
    dev2_app: 'dev2.themunim.com',
    dev1_account: 'dev1accounts.themunim.com',
    dev2_account: 'dev2accounts.themunim.com',
    dev_server_ip: '192.168.0.247:4001',
    dev1_server_ip: '192.168.0.247:4002',
    dev2_server_ip: '192.168.0.247:4003',
    qa_server_ip: '192.168.0.247:4005',
}
export default CommonServerRoute
